import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Game as GameType } from '~types';

import { SteamItemImage } from '../item';
import { useWinItem } from './hooks';
import Currency from '../Currency';
import { Price } from '~ui/Price';
import { useConfig } from '~components/hooks';

const WinItem: FunctionComponent = () => {
  const { t } = useTranslation();
  const [winGame] = useWinItem();
  const getConfig = useConfig();

  const { getItem, price } = winGame as GameType;

  return (
    <div className="win">
      <div className="text">{t('You won')}!</div>
      <div
        className="in-case-item active status-4"
        data-rar={getItem.color}
        data-audio="5.wav"
        data-volume="0.4"
      >
        <div className="in-case-cost">
          {getConfig.isEU ? (
            <>
              <Currency />
              <Price sum={price} />
            </>
          ) : (
            <>
              <Price sum={price} />
              <Currency />
            </>
          )}
        </div>
        <div className="in-case-item-wrap">
          <div className="img">
            <div className="in-case-item-bg" />
            <SteamItemImage url={getItem.getImage} size="350x350" />
          </div>
          <div className="in-case-info">
            <div className="in-case-item-name">{getItem.getName}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WinItem;
